export const BRAND_NAME = 'KartinAI'

/** Public asset in `frontend/public/` — bump `?v=` after logo file changes. */
export const BRAND_LOGO_SRC = '/Logo_kartinai.png?v=1'

export const BRAND_LOGO_ALT = BRAND_NAME

/** Bump after favicon asset changes (index.html + manifest.json). */
export const BRAND_FAVICON_VERSION = '4'
